import * as React from 'react';
import { useContext, useReducer, useState, useEffect } from "react";
import { MessagesContext } from "../common/context";
import { messagesReducer } from "../common/reducer";

// import * as Fabric from 'office-ui-fabric-react';
// import { graph } from '@pnp/graph';
// import * as MSGraph from '@microsoft/microsoft-graph-types';
// import { MSGraphClient } from '@microsoft/sp-http';
import log from 'loglevel';

import { AppLayout } from './AppLayout';
//import { personaPresenceSize } from 'office-ui-fabric-react';

let graphClient = {};

  export  const AppContext = ({ handleLogin, handleLogout ,accessToken, isAuthenticated }) =>{  

    const initialState = useContext(MessagesContext);
    const [state, dispatch] = useReducer(messagesReducer, initialState);
    log.info(`@AppContext`);

  //  useEffect(() => {
  //   if (accessToken != null && accessToken != ''){
  //     dispatch({ type: "SET_ACCESS_TOKEN", payload: { accessToken : accessToken} })
  //   }
  //     }, []);

    return (
          <MessagesContext.Provider value={{ state, dispatch }}>
              <AppLayout 
                handleLogin = {handleLogin}
                handleLogout = {handleLogout}
                accessToken = {accessToken}
                isAuthenticated = {isAuthenticated}
              />
          </MessagesContext.Provider>
    );
}

 